import { CategoryDisplayName } from '@oxappsec/ox-consolidated-categories';
import { CategoryIconsMap } from '@oxappsec/ox-consolidated-categories/lib/src/ox-categories/icons/index.js';

export const generateCategoryIcon = (category: CategoryDisplayName) => {
  return CategoryIconsMap.get(category);
};
